import { render } from "./EditaReporte.vue?vue&type=template&id=daa80f90"
import script from "./EditaReporte.vue?vue&type=script&lang=js"
export * from "./EditaReporte.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__